<main class="main">
  <!-- Div con titolo e sottotitolo -->
  <div class="main-content">
    <div class="dash-heading">
      <div class="dash-heading-icon"><i class="fas fa-gauge-high"></i></div>
      <div>
        <h1 class="main-title">{{ 'DASHBOARD.TITLE' | translate }}</h1>
        <p class="main-subtitle">{{ 'DASHBOARD.SUBTITLE' | translate }}</p>
      </div>
    </div>

    <!-- Sezione KPI - Statistiche Rapide
    <div class="kpi-section">
      <h2 class="section-title">{{ 'DASHBOARD.KPI.TITLE' | translate }}</h2>
      <div class="kpi-container">
        <div class="kpi-card">
          <div class="kpi-icon">
            <i class="fas fa-shipping-fast"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-number">24</div>
            <div class="kpi-label">{{ 'DASHBOARD.KPI.ACTIVE_SHIPMENTS' | translate }}</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon warning">
            <i class="fas fa-clock"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-number">8</div>
            <div class="kpi-label">{{ 'DASHBOARD.KPI.PENDING_ASSIGNMENT' | translate }}</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon danger">
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-number">3</div>
            <div class="kpi-label">{{ 'DASHBOARD.KPI.RETURNS_TO_PROCESS' | translate }}</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon danger">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-number">5</div>
            <div class="kpi-label">{{ 'DASHBOARD.KPI.DELAYED_WAYBILLS' | translate }}</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon success">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-number">156</div>
            <div class="kpi-label">{{ 'DASHBOARD.KPI.DELIVERED_TODAY' | translate }}</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Sezione con tre card -->
    <h2 class="section-title">{{ 'DASHBOARD.FUNCTIONALITIES.TITLE' | translate }}</h2>
    <div class="card-container"> 
      <a class="card cat-stats" [routerLink]="'/statistics'" *ngIf="functionService.canRead('statistics')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.STATISTICS.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.STATISTICS.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-shipments" [routerLink]="'/overview'" *ngIf="functionService.canRead('overview')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fa-solid fa-box"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.OVERVIEW.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.OVERVIEW.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-returns" [routerLink]="'/returns'" *ngIf="functionService.canRead('returns')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-undo"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.RETURNS.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.RETURNS.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-returns" [routerLink]="'/returns-history'" *ngIf="functionService.canRead('returns-history')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fa-solid fa-clock-rotate-left"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.RETURNS-HISTORY.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.RETURNS-HISTORY.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-returns" [routerLink]="'/returns-total'" *ngIf="functionService.canRead('returns-total')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-pie"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.RETURNS-TOTAL.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.RETURNS-TOTAL.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>      
      <a class="card cat-shipments" [routerLink]="'/shipment-request'" *ngIf="functionService.canRead('shipment-request')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-shipping-fast"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.SHIPMENT_REQUEST.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.SHIPMENT_REQUEST.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-returns" [routerLink]="'/return-request'" *ngIf="functionService.canRead('return-request')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-undo"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.RETURN_REQUEST.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.RETURN_REQUEST.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-shipments" [routerLink]="'/shipment-management'" *ngIf="functionService.canRead('shipment-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-clipboard-list"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.SHIPMENT_MANAGEMENT.TITLE' | translate }}</h3>
            <div class="card-badge card-badge-loading" *ngIf="isPendingWaybillsLoading" aria-busy="true">
              <i class="fas fa-spinner fa-spin card-badge-icon"></i>
              <span class="card-badge-row">{{ 'COMMON.LOADING' | translate }}</span>
            </div>
            <ng-container *ngIf="!isPendingWaybillsLoading && pendingWaybillsCount > 0">
              <div class="card-badge"
                   [class.card-badge-alert]="pendingWaybillsCount > 49"
                   [class.open]="expandedBadge === 'shipment-management'"
                   role="button" tabindex="0"
                   [attr.aria-expanded]="expandedBadge === 'shipment-management'"
                   (click)="toggleBadge($event, 'shipment-management')"
                   (keydown.enter)="toggleBadge($event, 'shipment-management')">
                <i class="fas fa-exclamation-circle card-badge-icon"></i>
                <span class="card-badge-row">
                  <span class="card-badge-count">{{ pendingWaybillsCount }}</span>
                  {{ 'DASHBOARD.CARDS.SHIPMENT_MANAGEMENT.BADGE_PENDING' | translate }}
                </span>
                <i class="fas fa-chevron-down card-badge-chevron"></i>
              </div>
              <div class="card-badge-details" *ngIf="expandedBadge === 'shipment-management'" (click)="stopCardNavigation($event)">
                <div class="card-badge-detail-row">
                  <span>{{ 'DASHBOARD.CARDS.SHIPMENT_MANAGEMENT.BADGE_PENDING_DETAIL' | translate }}</span>
                  <strong>{{ pendingWaybillsCount }}</strong>
                </div>
              </div>
            </ng-container>
            <p>{{ 'DASHBOARD.CARDS.SHIPMENT_MANAGEMENT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <!-- Gestione Danni (/damage-management): card nascosta dalla dashboard, la rotta resta
           attiva e raggiungibile via link diretto. Per riattivarla togliere il commento.
      <a class="card cat-shipments" [routerLink]="'/damage-management'" *ngIf="functionService.canRead('damages')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-exclamation-triangle"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.DAMAGES.TITLE' | translate }}</h3>
            <div class="card-badge card-badge-loading" *ngIf="isOpenDamagesLoading" aria-busy="true">
              <i class="fas fa-spinner fa-spin card-badge-icon"></i>
              <span class="card-badge-row">{{ 'COMMON.LOADING' | translate }}</span>
            </div>
            <ng-container *ngIf="!isOpenDamagesLoading && openDamagesCount > 0">
              <div class="card-badge"
                   [class.card-badge-alert]="openDamagesCount > 49"
                   [class.open]="expandedBadge === 'damages'"
                   role="button" tabindex="0"
                   [attr.aria-expanded]="expandedBadge === 'damages'"
                   (click)="toggleBadge($event, 'damages')"
                   (keydown.enter)="toggleBadge($event, 'damages')">
                <i class="fas fa-exclamation-circle card-badge-icon"></i>
                <span class="card-badge-row">
                  <span class="card-badge-count">{{ openDamagesCount }}</span>
                  {{ 'DASHBOARD.CARDS.DAMAGES.BADGE_OPEN_CLAIMS' | translate }}
                </span>
                <i class="fas fa-chevron-down card-badge-chevron"></i>
              </div>
              <div class="card-badge-details" *ngIf="expandedBadge === 'damages'" (click)="stopCardNavigation($event)">
                <div class="card-badge-detail-row">
                  <span>{{ 'DASHBOARD.CARDS.DAMAGES.BADGE_DETAIL_OPEN_CLAIMS' | translate }}</span>
                  <strong>{{ openDamagesCount }}</strong>
                </div>
              </div>
            </ng-container>
            <p>{{ 'DASHBOARD.CARDS.DAMAGES.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      -->
      <a class="card cat-anagraphic" [routerLink]="'/anagraphic'" *ngIf="functionService.canRead('anagraphic')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-address-book"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.ANAGRAFICA.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.ANAGRAFICA.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-shipments" [routerLink]="'/loading-list'" *ngIf="functionService.canRead('loading-list')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-list-check"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.BORDEREAU.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.BORDEREAU.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-routing" [routerLink]="'/change-tour'" *ngIf="functionService.canRead('change-tour')">
            <div class="card-content vertical">
                <div class="card-icon"><i class="fas fa-route"></i></div>
                <div class="card-text">
                    <h3>{{ 'DASHBOARD.CARDS.CHANGE-TOUR.TITLE' | translate }}</h3>
                    <p>{{ 'DASHBOARD.CARDS.CHANGE-TOUR.DESCRIPTION' | translate }}</p>
                </div>
            </div>      </a>
      <a class="card cat-routing" [routerLink]="'/overview-harmonizer'" *ngIf="functionService.canRead('overview-harmonizer')">
        <div class="card-content vertical">
            <div class="card-icon"><i class="fas fa-pencil"></i></div>
            <div class="card-text">
                <h3>{{ 'DASHBOARD.CARDS.OVERVIEW-HARMONIZER.TITLE' | translate }}</h3>
                <p>{{ 'DASHBOARD.CARDS.OVERVIEW-HARMONIZER.DESCRIPTION' | translate }}</p>
            </div>
        </div>      </a>
      <a class="card cat-routing" [routerLink]="'/discrepancy-list'" *ngIf="functionService.canRead('discrepancy-list')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-exclamation-triangle"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.DISCREPANCY_LIST.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.DISCREPANCY_LIST.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-picking" [routerLink]="'/picking-management'" *ngIf="functionService.canRead('picking-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-barcode"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.PICKING_MANAGEMENT.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.PICKING_MANAGEMENT.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <!-- TODO: Finance non ancora rilasciato - card nascosta
      <a class="card cat-stats" [routerLink]="'/finance'" *ngIf="functionService.canRead('finance')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-euro-sign"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.FINANCE.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.FINANCE.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      -->
      <a class="card cat-teal" [routerLink]="'/images'" *ngIf="functionService.canRead('images')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-images"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.IMAGES.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.IMAGES.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
        <a class="card cat-shipments" [routerLink]="'/overview-warehouse'" *ngIf="functionService.canRead('overview-warehouse')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-warehouse"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.OVERVIEW_WAREHOUSE.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.OVERVIEW_WAREHOUSE.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
        <a class="card cat-shipments" [routerLink]="'/trip-management'" *ngIf="functionService.canRead('trip-management')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-list-check"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.TRIP.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.TRIP.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
        <a class="card cat-picking" [routerLink]="'/overview-picking'" *ngIf="functionService.canRead('overview-picking')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-magnifying-glass-chart"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.OVERVIEW_PICKING.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.OVERVIEW_PICKING.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
        <a class="card cat-shipments" [routerLink]="'/stock'" *ngIf="functionService.canRead('stock')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-pallet"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.STOCK.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.STOCK.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
      <a class="card cat-system" [routerLink]="'/system'" *ngIf="functionService.canRead('system')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-cog"></i></div>
          <div class="card-text">
            <h3>{{ 'DASHBOARD.CARDS.SYSTEM.TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.CARDS.SYSTEM.DESCRIPTION' | translate }}</p>
          </div>
        </div>      </a>
    </div>
  </div>
</main>